import questionnaireApi from '@/api/questionnaire'

const actions = {
  getInvitationInfo ({ commit }, invitationId) {
    return questionnaireApi.getInvitationInfo(invitationId)
  },
  getQuestionnaireSteps ({ commit }, questionnaireId) {
    return questionnaireApi.getQuestionnaireSteps(questionnaireId)
  },
  getStepQuestions ({ commit }, payload) {
    return questionnaireApi.getStepQuestions(payload)
  },
  answerQuestions ({ commit }, payload) {
    return questionnaireApi.answerQuestions(payload)
  },
  checkQuestionnairePermission ({ commit }, invitationId) {
    return questionnaireApi.checkQuestionnairePermission(invitationId)
  },
  checkQuestionnaireInvitationCode ({ commit }, invitationCode) {
    return questionnaireApi.checkQuestionnaireInvitationCode(invitationCode)
  },
  getQuestionnaireWeChatSpread ({ commit }, invitationId) {
    return questionnaireApi.getQuestionnaireWeChatSpread(invitationId)
  },
  searchHmQuestions ({ commit }, params) {
    return questionnaireApi.searchHmQuestions(params)
  },
  getHmQuestionById ({ commit }, id) {
    return questionnaireApi.getHmQuestionById(id)
  },
  createHmQuestion ({ commit }, payload) {
    return questionnaireApi.createHmQuestion(payload)
  },
  updateHmQuestion ({ commit }, payload) {
    return questionnaireApi.updateHmQuestion(payload)
  },
  updateHmQuestionStatus ({ commit }, payload) {
    return questionnaireApi.updateHmQuestionStatus(payload)
  },
  getHmScoreScaleConfig () {
    return questionnaireApi.getHmScoreScaleConfig()
  },
  updateHmScoreScaleConfig ({ commit }, payload) {
    return questionnaireApi.updateHmScoreScaleConfig(payload)
  },
  searchHmQuestionnaires ({ commit }, params) {
    return questionnaireApi.searchHmQuestionnaires(params)
  },
  getHmQuestionnaireById ({ commit }, id) {
    return questionnaireApi.getHmQuestionnaireById(id)
  },
  createHmQuestionnaire ({ commit }, payload) {
    return questionnaireApi.createHmQuestionnaire(payload)
  },
  updateHmQuestionnaire ({ commit }, payload) {
    return questionnaireApi.updateHmQuestionnaire(payload)
  },
  copyHmQuestionnaire ({ commit }, id) {
    return questionnaireApi.copyHmQuestionnaire(id)
  },
  updateHmQuestionnaireStatus ({ commit }, payload) {
    return questionnaireApi.updateHmQuestionnaireStatus(payload)
  },
  validateHmQuestionnaireName (context, params) {
    return questionnaireApi.validateHmQuestionnaireName(params)
  }
}

export default {
  namespaced: true,
  actions
}
